import { IBrandReferralPromotion } from "@faire/web-api/indigofair/brand/referrals/IBrandReferralPromotion";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getReferralPromotions = ():
  | Array<IBrandReferralPromotion>
  | undefined => {
  return getGlobalProperty("referralPromotions");
};
